module.exports = __webpack_public_path__ + "static/media/fig_13a.df8d18c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_13a.jpg
// module id = 633
// module chunks = 0